/* eslint-disable */

import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import Hidden from "@material-ui/core/Hidden";
import { ButtonToolbar } from "react-bootstrap";
import { Redirect } from "react-router-dom";
import { RangePicker, Button, GenericLoader } from "../../../../shared/widgets";
import { PageWrapper } from "../../../../shared/layout";
import { selectDateFilter } from "../../../../redux/actions/dateFilterAction";
import { operatorWiseReportAction } from "../../../../redux/action-creators/distanceReportActionCreator";
import { routes } from "../../../../routing/routes";
import { exportExcel } from "../../../../shared/utils";
import "../reportView.css";

class OperatorWiseReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNo: 0,
      rowsPerPage: 10,
      count: 100,
      backdrop: false,
      totalPages: 0,
      sortBy: "",
      selected: [],
      showUploadXlsxModal: false,
    };
  }

  componentDidMount() {
    this.getList();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (prevProps && prevProps.cityFilter != this.props.cityFilter)
      || (prevProps && prevProps.operatorFilter != this.props.operatorFilter)
      || (prevProps && prevProps.dateFilter != this.props.dateFilter)
    ) {
      this.getList();
    }
  }

  handleDatesChange = (dates) => {
    if (dates.startDate && dates.endDate) {
      const fromDate = parseFloat(new Date(dates.startDate).getTime());
      const toDate = parseFloat(new Date(dates.endDate).getTime());
      this.props && this.props.selectDateFilter({ fromDate, toDate });
    }
  };

  onSortToggle = (value, key) => {
    this.setState(
      {
        sortBy: { [key]: value },
      },
      () => {
        this.getList();
      },
    );
  };

  handleChange = (input, value) => {
    this.setState({ [input]: value }, () => {
      if (input === "pageNo") {
        this.getList();
      }
    });
  };

  getList = () => {
    this.props.operatorWiseReportFetched(
      {
        pageNo: this.state.pageNo,
        pageSize: this.state.rowsPerPage,
        dateFilter: this.props.dateFilter,
        cityFilter: this.props.cityFilter,
        operatorFilter: this.props.operatorFilter,
        sortBy: this.state.sortBy,
      },
      "header",
    );
  };

  downloadExcel = async () => {
    const id = "exportOperatorWiseReport";
    const addOnFilter = {
      date: {
        fromDate: new Date(this.props.dateFilter.fromDate).getTime(),
        toDate: new Date(this.props.dateFilter.toDate).getTime(),
      },
      cityIdArr: this.props.cityFilter,
      operatorIdArr: this.props.operatorFilter,
    };
    await exportExcel({ id, addOnFilter });
  };

  render() {
    const {
      selectedReports,
    } = this.props;

    return (
      <div className="pageContainer">
        {!!this.props.settlementLoader && <GenericLoader absolute />}
        {selectedReports === "distance" && (
          <Redirect
            to={{
              pathname: routes.DISTANCE_REPORT,
              state: { from: this.props.location },
            }}
          />
        )}
        <PageWrapper>
          <PageWrapper.Header heading="Operator Wise Report" hideS>
            <Hidden only={["sm", "xs"]}>
              <div className="btn-wrapper">
                <Button
                  disable={false}
                  onClick={this.downloadExcel}
                  buttonText="Export"
                />
              </div>
              <div className="pull-right z-index-10">
                <ButtonToolbar>
                  <RangePicker
                    startDate={moment(new Date(this.props.dateFilter.fromDate))}
                    endDate={moment(new Date(this.props.dateFilter.toDate))}
                    monthsToDisplay={1}
                    onDatesChange={this.handleDatesChange}
                  />
                </ButtonToolbar>
              </div>
            </Hidden>
          </PageWrapper.Header>
        </PageWrapper>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    content:
      (state
        && state.Report
        && state.Report.operatorWiseData
        && state.Report.operatorWiseData.data)
      || [],
    totalItems:
      (state
        && state.Report
        && state.Report.operatorWiseData
        && state.Report.operatorWiseData.totalItems)
      || 0,
    headerLoader: state && state.loadingBar && state.loadingBar.header,
    settlementLoader:
      state && state.loadingBar && state.loadingBar.settlementLoader,
    dateFilter: state.DateFilter.selectedDateFilter,
    cityFilter: state.Cities.selectedCity,
    operatorFilter: state.Operators.selectedOperator,
    selectedReports: state.ReportsType.selectedReportsType,
  };
}

const mapDispatchToProps = (dispatch, state) => ({
  operatorWiseReportFetched: (params, loaderScope) => {
    dispatch(operatorWiseReportAction(params, loaderScope));
  },
  selectDateFilter: (value) => {
    dispatch(selectDateFilter(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(OperatorWiseReport);
